import { formatCurrency } from '../../../../../../../utils/CurrencyUtils';

export const fmtCents = (c: number | undefined | null): string =>
  c == null ? '—' : formatCurrency(c / 100);
